import { useEffect, useState } from "react";
import NoticeCard from "../components/NoticeCard";
import { firebaseReady } from "../firebase";
import { subscribeToNotices } from "../noticeService";
import "./NoticePage.css";

export default function NoticePage() {
  const [notices, setNotices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [expandedId, setExpandedId] = useState(null);
  const [retryKey, setRetryKey] = useState(0);

  useEffect(() => {
    setLoading(true);
    setError("");
    if (!firebaseReady) {
      setError("Firebase कन्फिगरेसन पूरा भएको छैन।");
      setLoading(false);
      return undefined;
    }

    try {
      return subscribeToNotices(
        (nextNotices, metadata) => {
          setNotices(nextNotices);
          setLoading(false);
          setError(
            metadata && metadata.fromCache
              ? "Firestore सर्भरसँग जडान हुन सकेन। इन्टरनेट जाँच गरी पुनः प्रयास गर्नुहोस्।"
              : "",
          );
        },
        (listenerError) => {
          setError(
            listenerError.code === "permission-denied"
              ? "सूचनाहरू हेर्ने अनुमति छैन।"
              : "सूचनाहरू लोड हुन सकेनन्। इन्टरनेट जाँच गरी पुनः प्रयास गर्नुहोस्।",
          );
          setLoading(false);
        },
      );
    } catch {
      setError("सूचनाहरू लोड हुन सकेनन्।");
      setLoading(false);
      return undefined;
    }
  }, [retryKey]);

  return (
    <div className="notice-page">
      <div className="notice-page-header">
        <h1>सूचना तथा विज्ञप्ति</h1>
        <p>
          नेपाली कांग्रेस कुश्मी-गाउँ काठमाडौं सम्पर्क समितिका आधिकारिक सूचनाहरू
        </p>
      </div>

      <div className="notice-container">
        {loading && (
          <p className="notice-state" role="status">
            सूचनाहरू लोड हुँदैछन्…
          </p>
        )}
        {error && (
          <div className="notice-error" role="alert">
            <p>{error}</p>
            <button
              type="button"
              className="btn-cancel"
              onClick={() => setRetryKey((key) => key + 1)}
            >
              पुनः प्रयास गर्नुहोस्
            </button>
          </div>
        )}
        {!loading && !error && notices.length === 0 ? (
          <div className="no-notices">
            <span>📋</span>
            <p>अहिले कुनै सूचना छैन।</p>
          </div>
        ) : !loading && !error ? (
          <div className="notices-list">
            {notices.map((notice) => (
              <NoticeCard
                key={notice.id}
                notice={notice}
                expanded={expandedId === notice.id}
                onToggle={(id) => setExpandedId(expandedId === id ? null : id)}
              />
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
}
